import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { dropRight } from 'lodash';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/toPromise';
import { FUNCTIONS_END_POINT_URL } from '../config/firebase-config';

@Injectable()
export class ReportService {

  constructor(private http: HttpClient, private db: AngularFireDatabase) { }

  /**
   * Returns a list of
   * @param start
   * @param limit
   */
  public listReports( endAt: any, limit: number = 200 ): Promise<seafrozen.IReportSummary[]> {

    /**
     * Options for the query
     * @see https://github.com/angular/angularfire2/blob/master/docs/4-querying-lists.md
     * */
    const queryOpts = {
      orderByChild: 'date',
      limitToLast: limit
    };

    if ( endAt ) {
      (<any>queryOpts).endAt = endAt;
    }

    const promise: Promise<seafrozen.IReportSummary[]> = new Promise((resolve: Function, reject: Function) => {
      this.db.list( '/reportsSummary', { query: queryOpts } )
      .take( 1 )
      .subscribe( (payload: seafrozen.IDbReportSummary[]) => {

        // If we're pagination (descending) we need to remove the last value
        //
        if ( endAt ) {
          payload = dropRight( payload, 1 );
        }

        const reports = payload.reverse();

        const summarisedReports: seafrozen.IReportSummary[] = reports.map( report => {
          /** Contains one summarised report */
          const summarisedReport: seafrozen.IReportSummary = {
            reportSummary: report,
            reportId: report.reportId
          }

          return summarisedReport;
        });
        console.log('[REPORT:SERVICE:LIST]', summarisedReports);
        resolve(summarisedReports);
      })
    });

    return Promise.resolve(promise);

  }

  public generateReport(reportId: string): Promise<any> {
    return this.http.get(`${FUNCTIONS_END_POINT_URL}/reports/create/${reportId}`, { responseType: 'text' }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/report.service.ts